import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../pages/Common';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="fixed top-16 sm:top-6 right-4 sm:right-6 z-50" data-testid="language-switcher">
      <button
        onClick={() => setLanguage(language === 'it' ? 'en' : 'it')}
        className="flex items-center gap-2 px-4 py-2 glass-panel rounded-sm border border-primary/50 hover:border-primary transition-all duration-300 group"
        data-testid="language-toggle-button"
      >
        <Globe className="w-5 h-5 text-primary group-hover:scale-110 transition-transform" />
        <span className="font-mono uppercase text-sm text-primary">
          {language === 'it' ? 'EN' : 'IT'}
        </span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
